// Port of `TypingIndicatorLabel` from ios/Sources/Views/TypingIndicatorView.swift — the one pure
// piece of that view (tested in QuickReactionsTests on Apple, so its port lives in
// quickReactions.test.ts).
//
// Who is typing HERE (this conversation or thread) outranks who is typing elsewhere in the same
// chat; a thread pane names the chat only when nobody in the thread itself is typing.
import { t, tf } from '../i18n/i18n';

function text(here: readonly string[], inChat: readonly string[]): string | null {
  if (here.length === 1) return tf('channel.typing.one', here[0]);
  if (here.length >= 2) return t('channel.typing.many');
  switch (inChat.length) {
    case 0:
      return null;
    case 1:
      return tf('channel.typing.oneInChat', inChat[0]);
    default:
      return t('channel.typing.manyInChat');
  }
}

export const TypingIndicatorLabel = {
  text,
} as const;
